import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {PohodaService} from '../../services/pohoda.service';
import {SnackService} from '../../services/snack.service';
import {DocumentCompanyService} from '../../services/document-company.service';
import {DocumentCompany} from '../../model/Entities/DocumentCompany';

@Component({
    selector: 'document-export-dialog',
    templateUrl: './document-export.dialog.component.html',
    styleUrls: ['./document-export.dialog.component.scss']
})
export class DocumentExportDialogComponent {

    exportOnlyUnexported = true;
    fromDate: Date = null;
    toDate: Date = null;
    documentCompanyId: number = null;
    includeExported = false;
    isExporting = false;
    documentCompanies: DocumentCompany[] = [];

    constructor(public dialog: MatDialogRef<DocumentExportDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private pohodaService: PohodaService,
                private snackService: SnackService,
                private documentCompanyService: DocumentCompanyService) {
        if (data) {
            if (data.documentCompanyId) {
                this.documentCompanyId = data.documentCompanyId;
            }
            if (data.from) {
                this.fromDate = data.from instanceof Date ? data.from : new Date(data.from);
            }
            if (data.to) {
                this.toDate = data.to instanceof Date ? data.to : new Date(data.to);
            }
            if (data.from || data.to) {
                this.exportOnlyUnexported = false;
            }
        }
        this.loadDocumentCompanies();
    }

    loadDocumentCompanies(): void {
        this.documentCompanyService.getSimpleList([]).subscribe((companies: DocumentCompany[]) => {
            this.documentCompanies = companies;
        });
    }

    export(): void {
        if (this.isExporting) {
            return;
        }

        if (!this.exportOnlyUnexported && (!this.fromDate || !this.toDate)) {
            return;
        }

        this.isExporting = true;

        const params: any = {
            exportOnlyUnexported: this.exportOnlyUnexported
        };

        if (this.documentCompanyId) {
            params.document_company_id = this.documentCompanyId;
        }

        if (!this.exportOnlyUnexported && this.fromDate && this.toDate) {
            params.fromDate = this.fromDate.toISOString();
            params.toDate = this.toDate.toISOString();
            params.includeExported = this.includeExported;
        }

        this.pohodaService.exportToXml(params).subscribe((blob: Blob) => {
            this.downloadFile(blob, 'export.zip');
            this.isExporting = false;
            this.dialog.close(true);
        }, (error) => {
            this.isExporting = false;
            this.snackService.showWarn('Žádný doklad nesplňuje zadané kritéria');
        });
    }

    onCheckboxChange(): void {
        if (this.exportOnlyUnexported) {
            this.fromDate = null;
            this.toDate = null;
            this.includeExported = false;
        }
    }

    private downloadFile(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}




// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentExportDialogComponent/document-export.dialog.component.ts